import type { AssigneeOrder } from '@/domain';
import { useDeviceSetting } from './useDeviceSetting';

/**
 * Whether the people in an assignment list are ordered least busy first.
 * Sections 7 and 8 of the request of 5 October 2026.
 *
 * One habit for every such list, remembered on the device as the other habits
 * are: somebody who assigns by workload wants that order in Assign, in Send for
 * rework and on a selection alike, tomorrow as well as today.
 */
export function useAssigneeOrder(): {
  order: AssigneeOrder;
  leastBusy: boolean;
  setLeastBusy: (on: boolean) => void;
} {
  const [leastBusy, setLeastBusy] = useDeviceSetting('assignees:leastBusy', false);
  return { order: leastBusy ? 'leastBusy' : 'usual', leastBusy, setLeastBusy };
}
